type Subscription = {
  status?: string;
  cancelAtPeriodEnd?: boolean;
  canceledAt?: string | null;
  currentPeriodEndedAt: string;
};

type BillingSummary = {
  trialEndedAt?: string | null;
};

export function getSubscriptionStatus(
  subscription: Subscription | null | undefined,
  billing: BillingSummary | null | undefined
): string {
  if (subscription?.cancelAtPeriodEnd || subscription?.canceledAt) {
    return 'Canceled';
  }
  if (subscription?.status) {
    return (
      subscription.status.charAt(0).toUpperCase() +
      subscription.status.slice(1).replace(/_/g, ' ')
    );
  }
  if (billing?.trialEndedAt && new Date(billing.trialEndedAt) > new Date()) {
    return 'Trialing';
  }
  return 'No subscription';
}

export function shouldShowNextBilling(
  subscription: Subscription | null | undefined
): boolean {
  return !subscription?.cancelAtPeriodEnd && !subscription?.canceledAt;
}

export function shouldShowAccessUntil(
  subscription: Subscription | null | undefined
): boolean {
  return Boolean(subscription?.cancelAtPeriodEnd);
}

export function shouldShowCanceledOn(
  subscription: Subscription | null | undefined
): boolean {
  return Boolean(subscription?.canceledAt);
}

export function isTrialing(
  billing: BillingSummary | null | undefined
): boolean {
  return Boolean(
    billing?.trialEndedAt && new Date(billing.trialEndedAt) > new Date()
  );
}
